module.exports = __webpack_public_path__ + "img/nestle_logo.561a54ef.png";